/* External Imports */

/* Built In Imports */
import { Box, Image, SimpleGrid } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { useMediaQuery } from 'react-responsive';

/**
 * @param {Object} sectionContent
 * @param {String} lang
 * @param {String} region
 * @returns
 */

const RemarketQuestionMind = ({ region, lang, sectionContent }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const programHeading = sectionContent?.find(
    e => e.fieldId === 'que-mind-heading'
  );
  const yogiImage = sectionContent?.find(e => e.fieldId === 'yogi-pic');
  // console.log(
  //   'sectionContent[1]?.image?.url ==> ',
  //   sectionContent[1]?.image?.url
  // );
  return (
    <Box bg="#F1EBDF">
      <Box
        p={{ base: '2rem 1.25rem 0', md: '7.5rem 1.25rem' }}
        borderRadius="lg"
        color={'#525252'}
        maxWidth="1920px"
        mx="auto"
      >
        {/* Centered Heading */}
        {programHeading && (
          <StructuredTextParser
            str={render(programHeading?.body)}
            fontSize={{ base: '1.625rem', md: '3.25rem' }}
            lineHeight={{ base: '1.95rem', md: '3.9rem' }}
            fontFamily="FedraSansStd-medium"
            textAlign="center"
            maxW={{ base: '100% !important', md: '70% !important' }}
            mb={{ base: '3px', md: '47px' }}
            mx="auto"
            className="que_mind_heading"
          />
        )}

        {/* Two-Column Layout for Items */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexDirection={{ base: 'column-reverse', lg: 'row' }}
          maxWidth="1200px"
          width="100%"
          mx="auto"
          gap={{ base: '2.68rem', lg: '1rem' }}
        >
          {yogiImage && (
            <Box maxWidth="517px" maxHeight="346px" textAlign="center">
              {isMobile ? (
                <Image
                  src={sectionContent[1]?.mobileImage?.url}
                  alt={sectionContent[1]?.image?.alt}
                />
              ) : (
                <Image
                  src={sectionContent[1]?.image?.url}
                  alt={sectionContent[1]?.image?.alt}
                />
              )}
            </Box>
          )}
          <SimpleGrid
            maxWidth="643px"
            columns={[1, 2]}
            spacing="2.25rem"
            mx="auto"
            pl="2rem"
          >
            <Box align="baseline" gap="1.25rem">
              <StructuredTextParser
                str={render(sectionContent[2]?.body)}
                color="#A81D28"
                fontSize={{ base: '1rem', md: '1.625rem' }}
                lineHeight={{ base: '1.4rem', md: '2rem' }}
                fontFamily="FedraSansStd-medium"
                className="remark_que_program"
              />
            </Box>
            <Box align="baseline" mt={{ base: '-3rem', sm: '0' }}>
              <StructuredTextParser
                str={render(sectionContent[3]?.body)}
                color="#A81D28"
                fontSize={{ base: '1rem', md: '1.625rem' }}
                lineHeight={{ base: '1.4rem', md: '2rem' }}
                fontFamily="FedraSansStd-medium"
                className="remark_que_program"
              />
            </Box>
          </SimpleGrid>
        </Box>
        <style>{`
        .remark_que_program ul{
          list-style: none;
          list-style-image: url('https://static.sadhguru.org/d/46272/1733399189-polygon_blue-icon.png');
        }
        .remark_que_program ul li{
          padding: 0px 0px 26px 8px !important;
          font-family: FedraSansStd-medium;
          color: #A81D28;
        }
        .que_mind_heading mark{
          background: none;
          color:#12166F
        }
        .que_mind_heading h2{
          color:#F37021
        }
      `}</style>
      </Box>
    </Box>
  );
};

export default RemarketQuestionMind;
